export default "__VITE_ASSET__f1d624d4__"